export default __webpack_public_path__ + "static/media/ideas_img.e34aaa1b.png";